// import React, { useState } from 'react'
// import Navbar from './Navbar'

// const AssessmentOne = () => {
//   const [answers, setAnswers] = useState({})

//   const handleChange = (questionNumber, value) => {
//     setAnswers({
//       ...answers,
//       [questionNumber]: value,
//     })
//   }

//   const questions = [
//     'Do you often have headaches?',
//     'Is your appetite poor?',
//     'Do you sleep badly?',
//     'Are you easily frightened?',
//     'Do you have shaky hands?',
//     'Do you feel nervous, tense or worried?',
//     'Is your digestion poor?',
//     'Do you have trouble thinking clearly?',
//     'Do you feel unhappy?',
//     'Do you cry more than usual?',
//     'Do you find it difficult to enjoy your daily activities?',
//     'Do you find it difficult to make decisions?',
//     'Is your daily work suffering?',
//     'Are you unable to play a useful part in life?',
//     'Have you lost interest in things?',
//     'Do you feel that you are a worthless person?',
//     'Has the thought of ending your life been on your mind?',
//     'Do you feel tired all the time?',
//     'Do you have uncomfortable feelings in your stomach?',
//     'Are you easily tired?',
//   ]

//   return (
//     <>
//       <Navbar />
//       <div
//         className='container-fluid py-4'
//         style={{
//           background: 'linear-gradient(to bottom left, #e6f7ff, #ffffff)',
//         }}
//       >
//         <div
//           style={{
//             maxWidth: '1000px',
//             margin: '0 auto',
//             padding: '20px',
//             fontFamily: 'Arial, sans-serif',
//           }}
//         >
//           <div className='container'>
//             <div className='row mb-4'>
//               <div className='col-12'>
//                 <h2
//                   style={{
//                     color: '#2D5272',
//                     textAlign: 'center',
//                     fontWeight: '600',
//                     fontFamily: 'Inter',
//                     fontsize: '45px',
//                     marginBottom: '50px',
//                   }}
//                 >
//                   Self-Reporting Questionnaire (SRQ) to screen for Mental
//                   Wellness.
//                 </h2>

//                 <p style={{ fontSize: '14px', lineHeight: '1.6' }}>
//                   WHO has developed the Self-Reporting Questionnaire (SRQ) as an
//                   instrument designed to screen for psychiatric disturbance,
//                   especially in developing countries.
//                 </p>

//                 <p style={{ fontSize: '14px', lineHeight: '1.6' }}>
//                   The SRQ consists of 20 questions that must be answered in Yes
//                   / No.
//                   <br />
//                   The SRQ-20 identifies those likely to be suffering from a
//                   mental disorder and who might therefore benefit from more
//                   detailed assessment and treatment. – WHO, Geneva, 1994.
//                 </p>

//                 <p style={{ fontSize: '14px', lineHeight: '1.6' }}>
//                   Each of the 20 items is scored 0 or 1.
//                   <br />A score of 1 indicates that the symptom was present
//                   during the past 1 month, and a score of 0 indicates that the
//                   symptom was absent. The maximum score is therefore 20.
//                 </p>

//                 <p
//                   style={{
//                     fontSize: '14px',
//                     fontWeight: 'bold',
//                     marginTop: '20px',
//                   }}
//                 >
//                   Instructions: For each item, tick one option: Yes/No that it
//                   was present or absent in the past 1 month.
//                 </p>
//               </div>
//             </div>

//             <form>
//               {questions.map((question, index) => (
//                 <div
//                   className='row mb-3 align-items-center'
//                   key={index}
//                   style={{
//                     padding: '10px',
//                     backgroundColor:
//                       index % 2 === 0
//                         ? 'rgba(240, 248, 255, 0.5)'
//                         : 'transparent',
//                     borderRadius: '5px',
//                   }}
//                 >
//                   <div className='col-md-8 col-sm-12'>
//                     <p style={{ margin: '0' }}>
//                       {index + 1}. {question}
//                     </p>
//                   </div>
//                   <div className='col-md-4 col-sm-12'>
//                     <div className='d-flex justify-content-start justify-content-md-end'>
//                       <div className='form-check form-check-inline'>
//                         <input
//                           className='form-check-input'
//                           type='radio'
//                           name={`question${index + 1}`}
//                           id={`yes${index + 1}`}
//                           value='yes'
//                           checked={answers[index + 1] === 'yes'}
//                           onChange={() => handleChange(index + 1, 'yes')}
//                           style={{
//                             cursor: 'pointer',
//                             appearance: 'none',
//                             width: '16px',
//                             height: '16px',
//                             border: '2px solid #002740',
//                             borderRadius: '50%',
//                             outline: 'none',
//                             display: 'inline-block',
//                             position: 'relative',
//                             backgroundColor:
//                               answers[index + 1] === 'yes'
//                                 ? '#002740'
//                                 : 'transparent',
//                           }}
//                         />
//                         <label
//                           className='form-check-label'
//                           htmlFor={`yes${index + 1}`}
//                           style={{ marginLeft: '5px', cursor: 'pointer' }}
//                         >
//                           yes
//                         </label>
//                       </div>
//                       <div
//                         className='form-check form-check-inline'
//                         style={{ marginLeft: '20px' }}
//                       >
//                         <input
//                           className='form-check-input'
//                           type='radio'
//                           name={`question${index + 1}`}
//                           id={`no${index + 1}`}
//                           value='no'
//                           checked={answers[index + 1] === 'no'}
//                           onChange={() => handleChange(index + 1, 'no')}
//                           style={{
//                             cursor: 'pointer',
//                             appearance: 'none',
//                             width: '16px',
//                             height: '16px',
//                             border: '2px solid #002740', // red border
//                             borderRadius: '50%',
//                             outline: 'none',
//                             display: 'inline-block',
//                             position: 'relative',
//                             backgroundColor:
//                               answers[index + 1] === 'no'
//                                 ? '#002740'
//                                 : 'transparent',
//                           }}
//                         />
//                         <label
//                           className='form-check-label'
//                           htmlFor={`no${index + 1}`}
//                           style={{ marginLeft: '5px', cursor: 'pointer' }}
//                         >
//                           no
//                         </label>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}

//               <div className='row mt-4'>
//                 <div className='col-12 text-center'>
//                   <button
//                     type='submit'
//                     className='btn btn-primary'
//                     style={{
//                       backgroundColor: '#2c5282',
//                       borderColor: '#2c5282',
//                       padding: '8px 24px',
//                       borderRadius: '25px',
//                     }}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default AssessmentOne

// import React, { useState, useEffect } from 'react'
// import Navbar from './Navbar'
// import axios from 'axios'
// import Swal from 'sweetalert2'
// import { useNavigate } from 'react-router-dom'

// const AssessmentOne = () => {
//   const [questions, setQuestions] = useState([])
//   const [answers, setAnswers] = useState({})
//   const [loadingQuestions, setLoadingQuestions] = useState(true)
//   const [submitting, setSubmitting] = useState(false)
//   const navigate = useNavigate()

//   // Fetch questions
//   useEffect(() => {
//     axios
//       .get('https://aimuseumbackend.teslabird.com/api/srq/questions/', {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('access')}`,
//         },
//       })
//       .then((res) => setQuestions(res.data))
//       .catch((err) => console.error('Failed to fetch questions', err))
//   }, [])

//   const handleChange = (questionId, value) => {
//     setAnswers({
//       ...answers,
//       [questionId]: value,
//     })
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault()
//     setSubmitting(true)

//     const formattedAnswers = Object.entries(answers).map(
//       ([questionId, answer]) => ({
//         question_id: parseInt(questionId),
//         answer: answer === 'yes',
//       })
//     )

//     try {
//       await axios.post(
//         'https://aimuseumbackend.teslabird.com/api/srq/submit/',
//         {
//           answers: formattedAnswers,
//         },
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${localStorage.getItem('access')}`,
//           },
//         }
//       )

//       Swal.fire({
//         icon: 'success',
//         title: 'Test Submitted!',
//         text: 'Redirecting to result...',
//         timer: 2000,
//         showConfirmButton: false,
//       })

//       setTimeout(() => navigate('/result-one'), 2000)
//     } catch (error) {
//       console.error('Submission failed', error)
//       Swal.fire('Error', 'Failed to submit the test', 'error')
//     } finally {
//       setSubmitting(false)
//     }
//   }

//   return (
//     <>
//       <Navbar />
//       <div
//         className='container-fluid py-4'
//         style={{
//           background: 'linear-gradient(to bottom left, #e6f7ff, #ffffff)',
//         }}
//       >
//         <div
//           style={{
//             maxWidth: '1000px',
//             margin: '0 auto',
//             padding: '20px',
//             fontFamily: 'Arial, sans-serif',
//           }}
//         >
//           {loadingQuestions ? (
//             <div className='text-center py-5'>
//               <div className='spinner-border text-primary' role='status'>
//                 <span className='visually-hidden'>Loading questions...</span>
//               </div>
//               <p className='mt-3'>Loading questions...</p>
//             </div>
//           ) : (
//             <div className='container'>
//               <div className='row mb-4'>
//                 <div className='col-12'>
//                   <h2
//                     style={{
//                       color: '#2D5272',
//                       textAlign: 'center',
//                       fontWeight: '600',
//                       fontFamily: 'Inter',
//                       fontsize: '45px',
//                       marginBottom: '50px',
//                     }}
//                   >
//                     Self-Reporting Questionnaire (SRQ) to screen for Mental
//                     Wellness.
//                   </h2>

//                   <p style={{ fontSize: '14px', lineHeight: '1.6' }}>
//                     WHO has developed the Self-Reporting Questionnaire (SRQ) as
//                     an instrument designed to screen for psychiatric
//                     disturbance, especially in developing countries.
//                   </p>

//                   <p style={{ fontSize: '14px', lineHeight: '1.6' }}>
//                     The SRQ consists of 20 questions that must be answered in
//                     Yes / No.
//                     <br />
//                     The SRQ-20 identifies those likely to be suffering from a
//                     mental disorder and who might therefore benefit from more
//                     detailed assessment and treatment. – WHO, Geneva, 1994.
//                   </p>

//                   <p style={{ fontSize: '14px', lineHeight: '1.6' }}>
//                     Each of the 20 items is scored 0 or 1.
//                     <br />A score of 1 indicates that the symptom was present
//                     during the past 1 month, and a score of 0 indicates that the
//                     symptom was absent. The maximum score is therefore 20.
//                   </p>

//                   <p
//                     style={{
//                       fontSize: '14px',
//                       fontWeight: 'bold',
//                       marginTop: '20px',
//                     }}
//                   >
//                     Instructions: For each item, tick one option: Yes/No that it
//                     was present or absent in the past 1 month.
//                   </p>
//                 </div>
//               </div>

//               <form onSubmit={handleSubmit}>
//                 {questions.map((q, index) => (
//                   <div key={q.id} className='row mb-3 align-items-center'>
//                     <div className='col-md-8'>
//                       <p>
//                         {index + 1}. {q.question_text}
//                       </p>
//                     </div>
//                     <div className='col-md-4 d-flex justify-content-end'>
//                       {['yes', 'no'].map((option) => (
//                         <div
//                           className='form-check form-check-inline'
//                           key={option}
//                         >
//                           <input
//                             className='form-check-input'
//                             type='radio'
//                             name={`question${q.id}`}
//                             id={`${option}${q.id}`}
//                             value={option}
//                             checked={answers[q.id] === option}
//                             onChange={() => handleChange(q.id, option)}
//                           />
//                           <label
//                             className='form-check-label'
//                             htmlFor={`${option}${q.id}`}
//                           >
//                             {option}
//                           </label>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 ))}

//                 <div className='text-center mt-4'>
//                   <button
//                     type='submit'
//                     className='btn btn-primary'
//                     disabled={submitting}
//                   >
//                     {submitting ? (
//                       <>
//                         <span
//                           className='spinner-border spinner-border-sm me-2'
//                           role='status'
//                           aria-hidden='true'
//                         ></span>
//                         Submitting...
//                       </>
//                     ) : (
//                       'Submit'
//                     )}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   )
// }

// export default AssessmentOne

import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import Navbar from './Navbar'

const AssessmentOne = () => {
  const [questions, setQuestions] = useState([])
  const [answers, setAnswers] = useState({})
  const [loadingQuestions, setLoadingQuestions] = useState(true)
  const [submitting, setSubmitting] = useState(false)
  const navigate = useNavigate()

  // Fetch SRQ questions on mount
  useEffect(() => {
    axios
      .get('https://aimuseumbackend.teslabird.com/api/srq/questions/', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access')}`,
        },
      })
      .then((res) => setQuestions(res.data))
      .catch((err) => console.error('Failed to fetch questions', err))
      .finally(() => setLoadingQuestions(false))
  }, [])

  const handleChange = (questionId, value) => {
    setAnswers({
      ...answers,
      [questionId]: value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitting(true)

    const formattedAnswers = Object.entries(answers).map(
      ([questionId, answer]) => ({
        question_id: parseInt(questionId),
        answer: answer === 'yes',
      })
    )

    try {
      await axios.post(
        'https://aimuseumbackend.teslabird.com/api/srq/submit/',
        { answers: formattedAnswers },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access')}`,
          },
        }
      )

      Swal.fire({
        icon: 'success',
        title: 'Test Submitted!',
        text: 'Redirecting to result...',
        timer: 2000,
        showConfirmButton: false,
      })

      setTimeout(() => navigate('/result-one'), 2000)
    } catch (error) {
      console.error('Submission failed', error)
      Swal.fire('Error', 'Failed to submit the test', 'error')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      <Navbar />
      <div
        className='container-fluid py-4'
        style={{
          background: 'linear-gradient(to bottom left, #e6f7ff, #ffffff)',
        }}
      >
        <div
          style={{
            maxWidth: '1000px',
            margin: '0 auto',
            padding: '20px',
            fontFamily: 'Arial, sans-serif',
          }}
        >
          {loadingQuestions ? (
            <div className='text-center py-5'>
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
              <p className='mt-3'>Loading questions...</p>
            </div>
          ) : (
            <div className='container'>
              <div className='row mb-4'>
                <div className='col-12'>
                  <h2
                    style={{
                      color: '#2D5272',
                      textAlign: 'center',
                      fontWeight: '600',
                      fontFamily: 'Inter',
                      fontSize: '45px',
                      marginBottom: '50px',
                    }}
                  >
                    Self-Reporting Questionnaire (SRQ) to screen for Mental
                    Wellness.
                  </h2>

                  <p style={{ fontSize: '14px', lineHeight: '1.6' }}>
                    WHO has developed the Self-Reporting Questionnaire (SRQ) as
                    an instrument designed to screen for psychiatric
                    disturbance, especially in developing countries.
                  </p>

                  <p style={{ fontSize: '14px', lineHeight: '1.6' }}>
                    The SRQ consists of 20 questions that must be answered in
                    Yes / No.
                    <br />
                    The SRQ-20 identifies those likely to be suffering from a
                    mental disorder and who might therefore benefit from more
                    detailed assessment and treatment. – WHO, Geneva, 1994.
                  </p>

                  <p style={{ fontSize: '14px', lineHeight: '1.6' }}>
                    Each of the 20 items is scored 0 or 1.
                    <br />A score of 1 indicates that the symptom was present
                    during the past 1 month, and a score of 0 indicates that the
                    symptom was absent. The maximum score is therefore 20.
                  </p>

                  <p
                    style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                      marginTop: '20px',
                    }}
                  >
                    Instructions: For each item, tick one option: Yes/No that it
                    was present or absent in the past 1 month.
                  </p>
                </div>
              </div>

              <form onSubmit={handleSubmit}>
                {questions.map((q, index) => (
                  <div key={q.id} className='row mb-3 align-items-center'>
                    <div className='col-md-8'>
                      <p>
                        {index + 1}. {q.question_text}
                      </p>
                    </div>
                    <div className='col-md-4 d-flex justify-content-end'>
                      {['yes', 'no'].map((option) => (
                        <div
                          className='form-check form-check-inline'
                          key={option}
                        >
                          <input
                            className='form-check-input'
                            type='radio'
                            name={`question${q.id}`}
                            id={`${option}${q.id}`}
                            value={option}
                            checked={answers[q.id] === option}
                            onChange={() => handleChange(q.id, option)}
                          />
                          <label
                            className='form-check-label'
                            htmlFor={`${option}${q.id}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
                <div className='text-center mt-4'>
                  <button
                    type='submit'
                    className='btn btn-primary'
                    disabled={submitting}
                  >
                    {submitting ? (
                      <>
                        <span
                          className='spinner-border spinner-border-sm me-2'
                          role='status'
                          aria-hidden='true'
                        ></span>
                        Submitting...
                      </>
                    ) : (
                      'Submit'
                    )}
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default AssessmentOne
